<template>
  <div class="events">
    <div class="events__wrapper">
      <div class="events__row">
        <p v-if="getEventsList === null">Es gibt im Moment keine Flohmärkte an diesem Ort</p>
        <div class="events__tile" v-for="event in getEventsList" v-else>
          <app-event-card :event="event" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AppEventCard from "@/components/AppEventCard"
  import { currentEventFormatter } from "../helpers/event-formatter";
  import { formatDate, formatTime, formatShortDate } from "../helpers/filters";
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: "Events",
    components: {
      AppEventCard
    },
    filters: {
      formatDate,
      formatTime,
      formatShortDate
    },
    computed: {
      ...mapGetters('events', ['getEventsList']),
      currentEvent() {
        let { eventId } = this.$route.query;
        if ( this.getEventsList && this.getEventsList.length ) {
          return this.getEventsList.filter(el => el.id === +eventId)[0]
        }
      }
    },
    mounted() {
      this.fetchEvents(this.$route.params.id);
      this.showEventViaParams()
    },
    methods: {
      ...mapActions('events', ['fetchEvents']),
      ...mapActions('bookEvents', ['setCurrentEvent']),
      showEventViaParams() {
        setTimeout(() => {
          let { eventId } = this.$route.query;

          if ( eventId ) {
            let formattedEvent = currentEventFormatter(this.currentEvent, this.$options.filters)
            this.setCurrentEvent(formattedEvent)
          }
        }, 1000)
      }
    }
  }
</script>
